import request from '@/utils/request'
import https from '@/utils/https.js'
export function getVideoTags() {
    return https({
        url: '/api/video/getVideoTags',
        method: 'post',
        data: {
        }
    })
}

export function getVideoList(page, tag_id) {
    return https({
        url: '/api/video/getVideoList',
        method: 'post',
        data: {
            page: page,
            tag_id: tag_id,
            size: '16'
        }
    })
}

export function getVideoUrl(id) {
    return https({
        url: '/api/video/getVideoUrl',
        method: 'post',
        data: {
            id: id,
        }
    })
}

export function getDownloadList(type, subject, year, before, page) {
    return https({
        url: '/api/tiku/lst',
        method: 'post',
        data: {
            type: type,
            subject: subject,
            year: year,
            before: before,
            page: page,
        }
    })
}

export function download(id) {
    return request({
        url: '/web/tiku/download',
        method: 'post',
        data: {
            id: id,
        }
    })
}

export function getVideoWatchList(page) {
    return request({
        url: '/web/video/getVideoWatchList',
        method: 'post',
        data: {
            // page: page,
        }
    })
}

export function downloadList(page) {
    return request({
        url: '/web/tiku/downloadList',
        method: 'post',
        data: {
            page: page,
        }
    })
}